import { Text, Box, Flex, Heading, Link } from "@chakra-ui/layout"
import React, { useEffect, useState } from "react"
import { useLocation } from "@reach/router"
import { getUserVerified } from "../../utils/loginInfo"
import { Image } from "../image"
import { addDays, format } from "date-fns"
import { usePurchasingCTAs } from "../form/usePurchasingCTAs"

export function AppConfirmation({
  title,
  description,
  ctaLabel,
  accountCtaLabel,
  ctaColor,
  image,
  mobileImage,
}) {
  const {
    appConfirmation,
    loginCta,
    emailVerification,
    titleBg,
    titleColor,
  } = usePurchasingCTAs()
  const [accountPath, setAccountPath] = useState(emailVerification?.link)

  const { pathname } = useLocation()

  useEffect(() => {
    const isVerified = getUserVerified()
    let acct
    if (pathname === appConfirmation?.link) {
      acct = isVerified ? "/account" : emailVerification?.link
    } else {
      acct = loginCta
    }

    setAccountPath(acct)
  }, [pathname])

  return (
    <Box p={{ base: `120px 20px 60px`, lg: "160px 0 120px" }}>
      <Box maxW="1100px" m="0 auto">
        <Flex flexWrap={{ base: `wrap`, lg: `nowrap` }}>
          <Box
            flex={{ base: `0 0 100%`, lg: `0 0 50%` }}
            display={{ base: `none`, lg: `block` }}
          >
            {image?.localFile?.childImageSharp && (
              <Image image={image.localFile.childImageSharp} />
            )}
          </Box>
          <Box flex={{ base: `0 0 100%`, lg: `0 0 50%` }} alignSelf="center">
            <Box maxW="370px" m="0 auto">
              <Heading
                fontWeight="600"
                fontSize={{ base: `30px` }}
                color="black"
                lineHeight={{ base: `24px` }}
                textAlign={{ base: `center` }}
                mb="30px"
                textTransform="uppercase"
              >
                <Box
                  as="span"
                  bg={titleBg}
                  color={titleColor}
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              </Heading>

              <Text
                fontSize="16px"
                lineHeight="24px"
                color="black"
                letterSpacing="-0.39px"
                textAlign="center"
                mb="21px"
                dangerouslySetInnerHTML={{ __html: description }}
              />

              {pathname === `/app-confirmation` && (
                <Text
                  fontSize="16px"
                  lineHeight="24px"
                  color="black"
                  letterSpacing="-0.39px"
                  textAlign="center"
                  mb="45px"
                >
                  Your FREE trial will end on{" "}
                  {format(addDays(new Date(), 7), "MMMM do, yyyy")}.
                </Text>
              )}

              <Box mt={pathname === `/app-confirmation` ? 0 : `30px`}>
                <Link
                  href={"/get-the-app"}
                  color={ctaColor}
                  _hover={{
                    textDecoration: "underline",
                  }}
                  textDecoration={"underline"}
                >
                  <Text
                    textAlign="center"
                    color={ctaColor}
                    fontWeight="600"
                    fontSize="18px"
                    lineHeight="30px"
                  >
                    {ctaLabel}
                  </Text>
                </Link>
              </Box>
              {accountCtaLabel && (
                <Box marginTop="24px">
                  <Link
                    href={accountPath}
                    color={ctaColor}
                    textDecoration="underline"
                  >
                    <Text
                      textAlign="center"
                      color={ctaColor}
                      fontWeight="600"
                      fontSize="18px"
                      lineHeight="30px"
                    >
                      {accountCtaLabel}
                    </Text>
                  </Link>
                </Box>
              )}
            </Box>
            {mobileImage && (
              <Box mt="20px" display={{ base: `block`, lg: `none` }}>
                {image?.localFile?.childImageSharp && (
                  <Image image={mobileImage.localFile.childImageSharp} />
                )}
              </Box>
            )}
          </Box>
        </Flex>
      </Box>
    </Box>
  )
}
